import { CSSObject } from '@emotion/core';

import { scale } from '@scripts/gds';

export const containerStyles: CSSObject = {
    marginBottom: scale(3),
};
